module.exports = __webpack_public_path__ + "img/admin.db8e8a6b.svg";